"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.useGetCurrentPeriod = void 0;
var _checkoutUtils = require("@ori/checkout-utils");
var _globalApiClientReact = require("@ori/global-api-client-react");
var _logger = require("../logger");
const useGetCurrentPeriod = (param)=>{
    let { isActive = true } = param;
    const swrOptions = {
        enabled: isActive,
        onSuccess: ()=>{
            (0, _logger.logDebug)('useGetCurrentPeriod() hook finished successfully');
        },
        ..._checkoutUtils.errorHandlingSwrOptions
    };
    const { data: currentPeriod, isValidating: isCurrentPeriodLoading } = (0, _globalApiClientReact.useGetPeriodsCurrentPeriod)(undefined, {
        swr: swrOptions
    });
    return {
        currentPeriod,
        isCurrentPeriodLoading
    };
};
exports.useGetCurrentPeriod = useGetCurrentPeriod;
